import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { userActivityService } from '../../services/userActivityService';

const ActivityTracker: React.FC<{ enabled: boolean; userId?: number }> = ({ enabled, userId }) => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);
  useEffect(() => {
    if (!enabled) { lastPath.current = null; return; }
    // Search text, tokens and other query parameters are deliberately excluded.
    const path = location.pathname === '/' ? '/dashboard' : location.pathname === '/admin' ? '/admin/employees' : location.pathname;
    const track = () => {
      const key = `${userId ?? ''}:${path}`;
      if (document.visibilityState === 'hidden' || path === '/login' || lastPath.current === key) return;
      lastPath.current = key;
      void userActivityService.trackPage(path).catch(() => { /* Analytics never interrupt navigation. */ });
    };
    track();
    document.addEventListener('visibilitychange', track);
    return () => document.removeEventListener('visibilitychange', track);
  }, [enabled, location.pathname, userId]);
  return null;
};

export default ActivityTracker;
